import React from 'react'
import SidebarMultiModal from './SidebarMultiModal';

const FlexibleMultiModal = () => {
     return (
          <SidebarMultiModal />
     )
}

export default FlexibleMultiModal;